export const WebsitePrefixMappings = [
  {
    websiteCode: 'web3__sections__international_americas',
    prefix: 'Americas',
  },
  {
    websiteCode: 'web3__sections__international_asia',
    prefix: 'Asia',
  },
  {
    websiteCode: 'web3__sections__international_austria',
    prefix: 'Austria',
  },
  {
    websiteCode: 'web3__sections__fix_the_future',
    prefix: 'Elite Companies',
  },
  {
    websiteCode: 'web3__sections__international_france',
    prefix: 'France',
  },
  {
    websiteCode: 'web3__sections__citywire_money',
    prefix: 'Funds Insider',
  },
  {
    websiteCode: 'web3__sections__international_germany',
    prefix: 'Germany',
  },
  {
    websiteCode: 'web3__sections__investment_trust_insider',
    prefix: 'Investment Trust Insider',
  },
  {
    websiteCode: 'web3__sections__international_italy',
    prefix: 'Italy',
  },
  {
    websiteCode: 'web3__sections__international_middle_east',
    prefix: 'Middle East',
  },
  {
    websiteCode: 'web3__sections__new_model_adviser',
    prefix: 'New Model Adviser',
  },
  {
    websiteCode: 'web3__sections__citywire_global',
    prefix: 'Selector',
  },
  {
    websiteCode: 'web3__sections__international_south_africa',
    prefix: 'South Africa',
  },
  {
    websiteCode: 'web3__sections__international_spain',
    prefix: 'Spain',
  },
  {
    websiteCode: 'web3__sections__international_switzerland',
    prefix: 'Switzerland',
  },
  {
    websiteCode: 'web3__sections__international_usa',
    prefix: 'Pro Buyer',
  },
  {
    websiteCode: 'web3__sections__international_registered_investment_advisers',
    prefix: 'RIA',
  },
  {
    websiteCode: 'web3__sections__wealth_manager',
    prefix: 'Wealth Manager',
  },
];
